// extracted by mini-css-extract-plugin
export default {"errorContainer":"ErrorSection_errorContainer__z-wVF","errorSection":"ErrorSection_errorSection__V6fba","link":"ErrorSection_link__MmSO5","errorText":"ErrorSection_errorText__7l2af"};